import { css, keyframes } from 'reakit/styled';
import { theme, palette } from 'styled-tools';
import 'styled-selector';
import '../styled/selector.js';
import 'lodash/get';
import '../styled/space.js';
import styled from '../styled/index.js';

var defaultDashArrayValue = 126;
var defaultDashOffset = '60px';
var sizes = {
  small: css(["&{font-size:14px;border-width:2px;}&{", ";}"], theme('fannypack.Spinner.sizes.small')),
  default: css(["&{", ";}"], theme('fannypack.Spinner.sizes.default')),
  medium: css(["&{font-size:28px;}&{", ";}"], theme('fannypack.Spinner.sizes.medium')),
  large: css(["&{font-size:36px;}&{", ";}"], theme('fannypack.Spinner.sizes.large'))
};
var rotate = keyframes(["from{transform:rotate(0deg);}to{transform:rotate(360deg);}"]);
var spinnerAnimation = css(["animation:", " 0.6s infinite linear;"], rotate);
var Circle = styled.circle.withConfig({
  displayName: "styled__Circle",
  componentId: "v4xo8u-0"
})(["stroke-dasharray:", ";stroke-dashoffset:", ";stroke:", ";transition:stroke-dashoffset 300ms cubic-bezier(0.4,0,0.2,1) 0ms;"], defaultDashArrayValue, function (props) {
  return typeof props.value === 'number' ? defaultDashArrayValue - props.value / 100 * defaultDashArrayValue + "px" : defaultDashOffset;
}, function (props) {
  return palette(props.color);
});
var Spinner = styled.svg.withConfig({
  displayName: "styled__Spinner",
  componentId: "v4xo8u-1"
})(["width:1em;height:1em;font-size:20px;transform:rotate(-90deg);", ";&{", ";}", ";"], function (props) {
  return typeof props.value === 'undefined' && spinnerAnimation;
}, theme('fannypack.Spinner.base'), function (props) {
  return props.styledSize && (sizes[props.styledSize] || css(["&{font-size:", ";}"], function (props) {
    return props.styledSize;
  }));
});

export default Spinner;
export { Circle, Spinner, defaultDashArrayValue, defaultDashOffset, rotate, sizes, spinnerAnimation };
